module.exports = __webpack_public_path__ + "static/images/af1ef6635143156c27dbc236e61781c9.svg";